module.exports = __webpack_public_path__ + "img/cardback.e348aa8e.jpg";